import { NgModule, EventEmitter } from "@angular/core";
import { Injectable } from "@angular/core";
import { ScreenControllerService } from "./core/controls/screen-controller.service";
import { Subject ,  Observable } from "rxjs";

@NgModule({})
@Injectable()
export class AppServices {
	//public rubricComplete: EventEmitter<string> = new EventEmitter<string>();
	constructor(private screenController: ScreenControllerService) {}

	private rubricComplete = new Subject<string>();
	rubricComplete$ = this.rubricComplete.asObservable();

	rubricCompleted(event: string) {
		this.rubricComplete.next(event);
	}

	private rubricLoaded = new Subject<string>();
	rubricLoaded$ = this.rubricLoaded.asObservable();
	rubricloadCompleted(event: string) {
		this.rubricLoaded.next(event);
	}

	private updateDefinition = new Subject<string>();
	updateDefinition$ = this.updateDefinition.asObservable();

	definationUpdated(event: string) {
		this.updateDefinition.next(event);
	}

	private jumpToPage = new Subject<string>();
	jumpToPage$ = this.jumpToPage.asObservable();

	jumpToPageFired(event: string) {
		this.jumpToPage.next(event);
	}

	private toInterface = new Subject<string>();
	toInterface$ = this.toInterface.asObservable();

	receivedFromRubric(event: string) {
		this.toInterface.next(event);
	}

	private activateButtons = new Subject<string>();
	activateButtons$ = this.activateButtons.asObservable();

	activateButtonsFired(event: string) {
		this.activateButtons.next(event);
	}

	private autoTransition = new Subject<string>();
	autoTransition$ = this.autoTransition.asObservable();

	triggerAutoTransition(event: string) {
		this.autoTransition.next(event);
	}

	private audioEvent = new Subject<string>();
	audioEvent$ = this.audioEvent.asObservable();
	emitAudioPath(event: string) {
		this.audioEvent.next(event);
	}
	private audioCCText = new Subject<string>();
	audioCCText$ = this.audioCCText.asObservable();
	emitCCText(event: string) {
		this.audioCCText.next(event);
	}
	private swfText = new Subject<string>();
	swfText$ = this.swfText.asObservable();
	emitswfText(event: string) {
		this.swfText.next(event);
	}

	private timeUpdateEvent = new Subject<string>();
	timeUpdateEvent$ = this.timeUpdateEvent.asObservable();
	onTimeUpdate(newTime) {
		this.timeUpdateEvent.next(newTime);
	}

	private audioCompleteEvent = new Subject<string>();
	audioCompleteEvent$ = this.audioCompleteEvent.asObservable();
	audioCompleteHandler(event: string) {
		this.audioCompleteEvent.next(event);
	}

	private audioStartEvent = new Subject<string>();
	audioStartEvent$ = this.audioStartEvent.asObservable();
	audioStartHandler(event: string) {
		this.audioStartEvent.next(event);
	}

	private audioPauseEvent = new Subject<string>();
	audioPauseEvent$ = this.audioPauseEvent.asObservable();
	pauseAudio() {
		this.audioPauseEvent.next();
	}

	private videoPauseEvent = new Subject<string>();
	videoPauseEvent$ = this.videoPauseEvent.asObservable();
	pauseVideo() {
		this.videoPauseEvent.next();
	}

	private rubricStateEvent = new Subject<string>();
	rubricStateEvent$ = this.rubricStateEvent.asObservable();
	rubricStateUpdate(event: any) {
		this.rubricStateEvent.next(event);
	}

	private courseCompletedEvent = new Subject<string>();
	courseCompleted$ = this.courseCompletedEvent.asObservable();
	courseIsCompleted() {
		this.courseCompletedEvent.next();
	}

	private appStateEvent = new Subject<string>();
	appStateEvent$ = this.appStateEvent.asObservable();
	applicationStateChanged(event: any) {
		this.appStateEvent.next(event);
	}

	private toggleLeftMenuEvent = new Subject<string>();
	toggleLeftMenuEvent$ = this.toggleLeftMenuEvent.asObservable();
	toggleLeftMenu(event: any) {
		this.toggleLeftMenuEvent.next(event);
	}

	private menuToggle = new Subject<string>();
	menuToggle$ = this.menuToggle.asObservable();
	emitMenuToggle(event: string) {
		this.menuToggle.next(event);
	}

	private stateSpecificButtonClickEvent = new Subject<string>();
	stateSpecificButtonClickEvent$ =
		this.stateSpecificButtonClickEvent.asObservable();
	stateSpecificButtonClickHandler(event: any) {
		this.stateSpecificButtonClickEvent.next(event);
	}

	private rubricDisposeEvent = new Subject<string>();
	rubricDisposeEvent$ = this.rubricDisposeEvent.asObservable();
	rubricDisposed(event: any) {
		this.rubricDisposeEvent.next(event);
	}

	private disableAudioPanelEvent = new Subject<string>();
	disableAudioPanelEvent$ = this.disableAudioPanelEvent.asObservable();
	disableAudioPanel(event: any) {
		this.disableAudioPanelEvent.next(event);
	}

	private trackingManagerInitilaizedEvent = new Subject<string>();
	trackingManagerInitilaizedEvent$ =
		this.trackingManagerInitilaizedEvent.asObservable();
	trackingManagerInitilaized() {
		this.trackingManagerInitilaizedEvent.next();
	}

	private configJSONLoaded = new Subject<string>();
	configJSONLoaded$ = this.configJSONLoaded.asObservable();
	configJSONLoadComplete(event: any) {
		this.configJSONLoaded.next(event);
	}

	private maxIdleTimeReached = new Subject<string>();
	maxIdleTimeReached$ = this.maxIdleTimeReached.asObservable();
	onMaxIdleTimeReached() {
		this.maxIdleTimeReached.next();
	}

	/*public rubricCompleted(event: string) {
    console.log("Rubric competed service");
    this.screenController.activeContinue = event === 'continue';
    if (!this.screenController.activeContinue) {
      this.screenController.triggerRubricComplete(event);
    }*/

    private keyPressedEvent = new Subject<any>();
    keyPressedEvent$ = this.keyPressedEvent.asObservable();
    keyPressEvent(e)
    {
        this.keyPressedEvent.next(e);
    }

	private updatePageTitle = new Subject<any>();
	updatePageTitle$ = this.updatePageTitle.asObservable();
	update_PageTitle(title: string, status: boolean) {
		this.updatePageTitle.next({ title: title, update: status });
	}
}
